export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_productName') || '产品名称',
    field: 'productName',
    minWidth: 250,
    align: 'left',
    fixed: 'left',
    slots: { default: 'productName' },
  },
  {
    title: that.$l('table_label_specColor') || '规格颜色',
    field: 'specColor',
    minWidth: 140,
    align: 'left',
    slots: { default: 'specColor' },
  },
  {
    title: that.$l('table_label_productNo') || '产品编号',
    field: 'productNo',
    minWidth: 190,
    align: 'left',
    slots: { default: 'productNo' },
  },
  {
    title: that.$l('table_label_productUnit') || '产品单位入数',
    field: 'productUnit',
    minWidth: 120,
    align: 'left',
    slots: { default: 'productUnit' },
  },
  {
    title: that.$l('table_label_unitInContainerQty') || '总产品数量',
    field: 'unitInContainerQty',
    minWidth: 120,
    headerAlign: 'center',
    isTotalColumn: true,
    align: 'center',
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_specInContainerQty') || '总规格数量',
    field: 'specInContainerQty',
    minWidth: 120,
    headerAlign: 'center',
    isTotalColumn: true,
    align: 'center',
    slots: { default: 'specInContainerQty' },
  }
]
